import { ReactNode } from 'react';
import { useTheme } from 'styled-components';

import { Theme } from '../../theme';
import { UIProps } from '../../theme/mixins';
import UI from '../UI';

interface QuantityLabelProps {
  children: ReactNode;
  sc?: UIProps;
}

const QuantityLabel = ({ children, sc }: QuantityLabelProps) => {
  const theme = useTheme() as Theme;

  return (
    <UI.Span
      sc={{
        background: 'gray.200',
        inlineBlock: true,
        small: true,
        px: 0.75,
        py: 0.25,
        ...sc,
      }}
      style={{
        fontWeight: 500,
        color: sc && sc.background ? theme.getTitleColor(theme.getColor(sc.background)) : undefined,
      }}
    >
      {children}
    </UI.Span>
  );
};

export default QuantityLabel;
